import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './session.types';
import * as constants from './session.constants';

export const storeSession = generateStoreResourceAction<types.ISession>(constants.STORE_SESSION);
export const clearSession = generateClearResourceAction(constants.CLEAR_SESSION);
